import { Mark } from 'tiptap'
import { TextSelection, AllSelection } from 'prosemirror-state'

export const DEFAULT_FONT_FAMILY = [
  { text: 'Roboto', key: `"Roboto Condensed", sans-serif` },
  { text: 'Times New Roman', key: "'Times New Roman', serif" },
  { text: 'Courier', key: 'Courier, monospace' },
  { text: 'Comic Sans', key: 'Comic Neue' },
  { text: 'PT Sans', key: `"PT Sans", sans-serif` },
  { text: 'Courier Prime', key: `"Courier Prime", monospace` },
]

function markApplies(doc, ranges, type) {
  for (let i = 0; i < ranges.length; i++) {
    const { $from, $to } = ranges[i]
    let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false
    doc.nodesBetween($from.pos, $to.pos, (node) => {
      if (can) return false

      can = node.inlineContent && node.type.allowsMarkType(type)
      return true
    })
    if (can) return true
  }
  return false
}

function applyMark(tr, markType, attrs) {
  if (!tr.selection || !tr.doc || !markType) return tr

  // @ts-ignore
  const { empty, $cursor, ranges } = tr.selection

  if ((empty && !$cursor) || !markApplies(tr.doc, ranges, markType)) return tr

  if ($cursor) {
    tr = tr.removeStoredMark(markType)
    return attrs ? tr.addStoredMark(markType.create(attrs)) : tr
  }

  let has = false
  for (let i = 0; !has && i < ranges.length; i++) {
    const { $from, $to } = ranges[i]
    has = tr.doc.rangeHasMark($from.pos, $to.pos, markType)
  }

  for (let i = 0; i < ranges.length; i++) {
    const { $from, $to } = ranges[i]
    if (has) {
      tr = tr.removeMark($from.pos, $to.pos, markType)
    }
    if (attrs) {
      tr = tr.addMark($from.pos, $to.pos, markType.create(attrs))
    }
  }

  return tr
}

function setFontFamily(tr, type, fontFamily) {
  const { selection } = tr

  if (
    !(selection instanceof TextSelection || selection instanceof AllSelection)
  ) {
    return tr
  }

  const attrs =
    fontFamily && fontFamily !== DEFAULT_FONT_FAMILY
      ? { fontFamily: fontFamily }
      : null
  tr = applyMark(tr, type, attrs)
  return tr
}

export default class FontFamily extends Mark {
  get name() {
    return 'font_family'
  }

  get defaultOptions() {
    return {
      fontFamily: DEFAULT_FONT_FAMILY,
    }
  }

  get schema() {
    return {
      attrs: {
        fontFamily: '',
      },
      inline: true,
      group: 'inline',
      parseDOM: [
        {
          style: 'font-family',
          getAttrs: (fontFamily) => {
            const attrs = {}
            if (!fontFamily) return attrs

            return {
              fontFamily,
            }
          },
        },
      ],
      toDOM(node) {
        const { fontFamily } = node.attrs
        const attrs = {}

        if (fontFamily) {
          attrs.style = `font-family: ${fontFamily}`
        }
        return ['span', attrs, '']
      },
    }
  }

  commands({ type }) {
    return (fontFamily) => (state, dispatch) => {
      let { tr } = state
      tr = setFontFamily(
        state.tr.setSelection(state.selection),
        type,
        fontFamily
      )
      if (tr.docChanged || tr.storedMarksSet) {
        dispatch && dispatch(tr)
        return true
      }
      return false
    }
  }
}
